import { AxiosResponse } from "axios";
import apiClient from "./apiClient";
import Cookies from "js-cookie";

const getAuthHeaders = () => ({
  Authorization: `Bearer ${Cookies.get("access_token")}`,
  "Content-Type": "application/json",
});

/** GET /cache/all — все кэши */
export const getAllCaches = async (): Promise<unknown> => {
  const response: AxiosResponse = await apiClient.get(
    `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/cache/all`,
    { headers: getAuthHeaders() },
  );
  return response.data;
};

/** POST /cache/delete — очистка по списку ключей */
export const deleteCachesByKeys = async (keys: string[]): Promise<unknown> => {
  const response: AxiosResponse = await apiClient.post(
    `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/cache/delete`,
    { keys },
    { headers: getAuthHeaders() },
  );
  return response.data;
};

/** POST /cache/clean-all — полная очистка кэша */
export const cleanAllCaches = async (): Promise<unknown> => {
  const response: AxiosResponse = await apiClient.post(
    `${process.env.REACT_APP_URL_MAIN_SERVICE}/operator/cache/clean-all`,
    {},
    { headers: getAuthHeaders() },
  );
  return response.data;
};
